module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAVCAYAAABPPm7SAAAACXBIWXMAAAsSAAALEgHS3X78AAAAzElEQVQ4y7WTURHCMBBElw7/jQRwEAmVUBxUQiUgoRLAARIqAQmVEBQ8ftKZEJLQTIc3cz+5685mcxWgqAxwBRyfPIAuno8/tsBCmSEnYIAn2+hTAmM0tPiz3tuPe18CczDgvKOwP0UiXSwQMmXCDRkBNUrjNpwZSVmBzewWWO82U88CDKl0a3CNJLvjAm0pg5eki6SzpHspg/nXuvpK/iMlB6fozU2tg3Cds0GXHLRBwPZvi3TM7P3K5Pu29Ar9jkWaD4Akdb5qcJJubwNSkIJFqZreAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/general-icons/icon_lock.png
// module id = 667
// module chunks = 0